export const ScanKizCreatePluginSettings: IPluginSettings = {
    name: 'КИЗ-ы',
    mnemocode: 'create_modal_kiz_plugin',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'idGlobal',
            visibility: false,
            width: 150
        },
        {
            order: 1,
            propertyName: 'isTrusted',
            propertyType: 'boolean',
            displayName: 'Доверенный',
            visibility: false,
            width: 100
        },
        {
            order: 2,
            propertyName: 'barcode',
            propertyType: 'string',
            displayName: 'Штрихкод',
            visibility: true,
            width: 120
        },
        {
            order: 3,
            propertyName: 'decodedBarcode',
            propertyType: 'string',
            displayName: 'Декодированный штрих-код',
            visibility: true,
            width: 120
        },
        {
            order: 4,
            propertyName: 'gtin',
            propertyType: 'string',
            displayName: 'Идентификационный номер ЛП',
            visibility: true,
            width: 120
        },
        {
            order: 5,
            propertyName: 'sGtin',
            propertyType: 'string',
            displayName: 'sGtin',
            visibility: true,
            width: 120
        }, {
            order: 6,
            propertyName: 'gtinSGtin',
            propertyType: 'string',
            displayName: 'gtinSGtin',
            visibility: true,
            width: 120
        },
        {
            order: 7,
            propertyName: 'idError',
            propertyType: 'number',
            displayName: 'idError',
            visibility: false,
            width: 100
        },
       
    ]
}
